export function isObjectStriclyEqual<T extends object>(
  a: T,
  b: T,
  exclude?: (keyof T)[],
) {
  if (!a && b) {
    return false;
  }

  if (a && !b) {
    return false;
  }

  if (!a && !b) {
    return true;
  }

  if (!(a instanceof Object) || !(b instanceof Object)) {
    return false;
  }

  let keysA = Object.keys(a);
  if (exclude) {
    keysA = keysA.filter((key) => !exclude.includes(key as keyof T));
  }

  let keysB = Object.keys(b);
  if (exclude) {
    keysB = keysB.filter((key) => !exclude.includes(key as keyof T));
  }

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    const va = a[key as keyof T];
    const vb = b[key as keyof T];
    if (Array.isArray(va)) {
      if (!isArrayStrictlyEqual(va, vb as unknown[])) {
        return false;
      }

      continue;
    }

    if (va instanceof Object) {
      if (!isObjectStriclyEqual(va, vb as object)) {
        return false;
      }

      continue;
    }

    if (va !== vb) {
      return false;
    }
  }

  return true;
}

export function isArrayStrictlyEqual<T>(a: T[], b: T[]) {
  if (!a && b) {
    return false;
  }

  if (a && !b) {
    return false;
  }

  if (!a && !b) {
    return true;
  }

  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }

  if (a.length !== b.length) {
    return false;
  }

  if (a.length === 0) {
    return true;
  }

  const isArrayType = Array.isArray(a[0]);
  const isObjectType = a[0] instanceof Object;
  for (let i = 0; i < a.length; i++) {
    if (isArrayType) {
      if (!isArrayStrictlyEqual(a[i] as unknown[], b[i] as unknown[])) {
        return false;
      }

      continue;
    }

    if (isObjectType) {
      if (!isObjectStriclyEqual(a[i] as object, b[i] as object)) {
        return false;
      }

      continue;
    }

    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}
